import {clsx} from '@gfiber/typesmith';
import {Accordion as BaseAccordion} from '@base-ui/react/accordion';
import type * as React from 'react';
import styles from './Accordion.module.scss';

export interface AccordionProps {
  children: React.ReactNode;
  handle: React.ReactNode;
  open?: boolean;
  disabled?: boolean;
  className?: string;
  onValueChange?: (value: string[]) => void;
}

export const ACCORDION_ITEM_VALUE = 'item-1';

export const Accordion: React.FC<AccordionProps> = ({
  children,
  handle,
  open,
  disabled,
  className,
  onValueChange,
}) => {
  const controlledValue =
    open === true ? [ACCORDION_ITEM_VALUE] : open === false ? [] : undefined;

  return (
    <BaseAccordion.Root
      value={controlledValue}
      onValueChange={onValueChange}
      className={clsx(styles.accordion, className)}
      disabled={disabled}
    >
      <BaseAccordion.Item
        value={ACCORDION_ITEM_VALUE}
        className={styles.item}
      >
        {handle}
        {children}
      </BaseAccordion.Item>
    </BaseAccordion.Root>
  );
};
